<script>
  export let channelGroup;
  export let darkTheme = false;
</script>


<row align-center class="channel-group" class:dark={darkTheme}>
  <ion-icon name="archive-outline"></ion-icon>
    {channelGroup.name}
</row>


<style>
  .channel-group {
    color: #888;
    height: 40px;
  }

  .dark {
    color: #ccc;
  }


  ion-icon {
    width: 32px;
  }
</style>